package com.vizio.redwolf.consent.model

import com.vizio.redwolf.consent.serialization.ConsentContentNoExternalTypeSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class ConsentClientResponse(
    val consentClientData: List<ConsentClientData>? = null,
    val consentGroups: List<ConsentGroup>? = null,
    val consentActions: List<ConsentActionData>,
    val consentToken: String,
)

@Serializable
@JsExport
data class ConsentClientData(
    // TODO These nullables can be removed later when confirmed with EPAM
    val id: String? = null,
    val version: Int? = null,
    val title: String? = null,
    val language: String? = null,

    @Serializable(with = ConsentContentNoExternalTypeSerializer::class)
    val consentContent: ConsentContent
)

@Serializable
@JsExport
sealed class ConsentContent {
    @Serializable
    @SerialName("HtmlCss")
    data class HtmlCss(val htmlInfo: ResourceInfo, val cssInfo: List<ResourceInfo>) : ConsentContent()

    @Serializable
    @SerialName("Text")
    data class Text(val textInfo: ResourceInfo) : ConsentContent()

    fun <R> fold(
        onHtmlCss: (HtmlCss: HtmlCss) -> R,
        onText: (Text: Text) -> R
    ): R {
        return when (this) {
            is HtmlCss -> onHtmlCss(HtmlCss(this.htmlInfo, this.cssInfo))
            is Text -> onText(Text(this.textInfo))
        }
    }
}

@Serializable
@JsExport
data class ResourceInfo(
    val url: String,
    val content: String? = null
)